export default {
  path: "/HighlightedTopic/CrashInvestigation",
  name: "Highlighted Topic - Crash Investigation",
  type: "highlightedTopic",
  htmlContent: "HT-CrashInvestigation.html",
  keyPoints: [
    "Conduct interviews in a calm, neutral manner to ensure accuracy and minimize bias.",
    "Ask open-ended questions to encourage detailed responses.",
    "Document all responses verbatim when possible.",
    "Correlate statements with physical evidence and electronic data (e.g., Event Data Recorder (EDR), onboard systems, dashcams).",
    "Ensure consistency between the Narrative, Diagram, and Structured Questioning responses.",
    "Make sure your questions are answered and document any involved party that <u>refuses</u> to or is unable to answer a <u>question</u>.",
  ],
  scenarios: [],
  keywords: ['crash investigation', 'investigation', 'structured questioning', 'interviewing', 'scene assessment'],
};